import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';

import { ApiError, AuthService, BaseForm, BaseFormService, MessageService } from '../../../core';

import { CondicaoPagamento } from '../condicao-pagamento';
import { tiposCondicoesPagamento } from '../tipo';
import { condicaoPagamentoSituacoes } from '../condicao-pagamento-situacao';
import { CondicaoPagamentoCrudHttpService } from '../services';
import { CondicaoPagamentoPrazoComponent } from '../prazo';
import { FormaPagamento, formaPagamentoSituacaoAtiva, FormaPagamentoFilter, FormaPagamentoCrudHttpService } from '../../forma-pagamento';

@Component({
    selector: 'sgt-condicao-pagamento-form',
    templateUrl: './condicao-pagamento-form.component.html',
    styleUrls: ['./condicao-pagamento-form.component.less']
})
export class CondicaoPagamentoFormComponent implements BaseForm<CondicaoPagamento>, OnInit {
    entity: CondicaoPagamento;
    editMode: boolean;
    @ViewChild('form') form: NgForm;

    tipos = tiposCondicoesPagamento;
    situacoes = condicaoPagamentoSituacoes;
    formasPagamentos: FormaPagamento[];
    @ViewChild('prazoCadastro') prazoCadastro: CondicaoPagamentoPrazoComponent;

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private authService: AuthService,
                private messageService: MessageService,
                private baseFormService: BaseFormService,
                private condicaoPagamentoCrudHttpService: CondicaoPagamentoCrudHttpService,
                private formaPagamentoCrudHttpService: FormaPagamentoCrudHttpService) { }

    ngOnInit() {
        this.baseFormService.getIdParam(this.activatedRoute).then(id => {
            if (!id) {
                this.insert();
            } else {
                this.edit(id);
            }
        });
    }

    /** Pesquisa as formas de pagamentos */
    private searchFormasPagamentos(formaPagamento: FormaPagamento) {
        this.formasPagamentos = [];
        const filter = new FormaPagamentoFilter();
        filter.situacao = formaPagamentoSituacaoAtiva.id;
        this.formaPagamentoCrudHttpService.searchWithFilter(filter)
            .subscribe(
                formasPagamentos => {
                    this.formasPagamentos = formasPagamentos;

                    // Se for informada a forma de pagamento, verificamos se ela não se encontra no array de formas de pagamento
                    if (formaPagamento) {
                        // Se não for encontrada a forma de pagamento informada, então adicionamos ela ao array
                        if (this.formasPagamentos?.findIndex(formaPagamentoFilter => formaPagamentoFilter.id === formaPagamento.id) < 0) {
                            this.formasPagamentos.unshift(formaPagamento);
                        }
                    }
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as formas de pagamentos')
            );
    }

    load(id: number) {
        this.condicaoPagamentoCrudHttpService.load(id)
            .subscribe(
                entity => {
                    this.entity = entity;

                    this.searchFormasPagamentos(this.entity?.formaPagamento);
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao carregar a condição de pagamento', error);
                    this.cancel();
                }
            );
    }

    insert() {
        this.editMode = false;
        this.entity = new CondicaoPagamento();
        this.entity.idEmpresa = this.authService.getIdEmpresa();

        this.searchFormasPagamentos(null);
    }

    edit(id: number) {
        this.editMode = true;
        this.load(id);
    }

     /** Valida se pode realizar o save */
    private validateSave(): boolean {
        // Prazos
        if (!this.prazoCadastro.isValid()) {
            return false;
        }

        return true;
    }


    private beforeSave() {
        // Prazos
        this.prazoCadastro.resolve();
    }

    save() {
        if (this.validateSave()) {
            this.beforeSave();
            this.baseFormService.save<CondicaoPagamento>(this.entity, this.form, this.editMode, this.condicaoPagamentoCrudHttpService)
                .then(entity => {
                    this.messageService.success('', 'Condição de pagamento salva com sucesso');
                    this.afterSave(entity);
                })
                .catch(error => {});
        }
    }

    afterSave(entity: CondicaoPagamento) {
        this.cancel();
    }

    cancel() {
        this.baseFormService.cancel(this.activatedRoute);
    }
}
